/* eslint-disable no-case-declarations */
import {
  SYMBOL_LIVE_FEED,
  SYMBOL_LIVE_FEED_RESET,
} from '../../constants/ActionTypes';
import { updateSymbolLiveFeed } from './updaters';

const symbolLiveFeed = (state = { data: {}, updatedAt: null }, action) => {
  switch (action.type) {
    case SYMBOL_LIVE_FEED:
      const { data: dataSymbolLiveFeed } = updateSymbolLiveFeed(state, action);

      return {
        ...state,
        data: dataSymbolLiveFeed,
        updatedAt: new Date(),
      };
    case SYMBOL_LIVE_FEED_RESET:
      return {
        ...state,
        data: {},
        updatedAt: null,
      };
    default:
      return state;
  }
};

export default symbolLiveFeed;
